var exports = {
  "Du": "xf0b3b88a--b74ee4--container_inner",
  "ep": "xf0b3b88a--b74ee4--container-mobile_inner",
};

module.exports = exports;
